var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',_vm._l((_vm.propsUsers),function(user,index){return _c('b-col',{key:index,staticClass:"mb-32",attrs:{"cols":"6","md":"4","lg":"3","xl":"2"}},[_c('b-card',{staticClass:"text-center"},[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('b-avatar',{staticClass:"bg-transparent",attrs:{"src":user.img,"size":"64px"}})],1)],1)],1)],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }